import React, { useEffect, useState } from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import { API_BASE } from "../api/apiConfig";

const Faq = () => {
  const [faqItems, setFaqItems] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(4); // Show 4 items initially

  useEffect(() => {
    fetch('https://jsonplaceholder.typicode.com/posts?_limit=20')
      .then((res) => res.json())
      .then((data) => {
        const formattedData = data.map(item => ({
          question: item.title,
          answer: item.body
        }));
        setFaqItems(formattedData);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching FAQ:', err);
        setFaqItems([]);
        setLoading(false);
      });
  }, []);

  const toggleFaq = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <Header />
      <main className="min-h-screen bg-[#0F172A]">
        <section className="relative overflow-hidden bg-gradient-to-b from-[#0F172A] to-[#1E293B] py-20 md:py-28">
          <div className="absolute inset-0 z-0 opacity-20">
            <img alt="Background pattern" className="object-cover" src="/diagonal-pattern.png" />
          </div>
          <div className="container relative z-10 mx-auto px-4 text-center md:px-6">
            <div className="mx-auto max-w-3xl">
              <h1 className="mb-6 text-4xl font-bold tracking-tight text-white md:text-5xl lg:text-6xl">
                Faq<span className="text-primary">'</span>s
              </h1>
              <p className="mb-8 text-lg text-gray-300 md:text-xl">
                Find answers to the most commonly asked questions about our services, pricing, support, and more.
              </p>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <div className="bg-slate-100 py-10 md:py-14 text-slate-800">
          <div className="max-w-6xl mx-auto px-4 sm:px-5 md:px-6">
            <div className="mb-6 md:mb-8 text-center reveal-on-scroll revealed">
              <div className="mb-2 md:mb-3 inline-flex items-center rounded-full border border-primary/30 bg-primary/10 px-2.5 py-1 text-sm md:text-base font-medium text-primary hover-lift">
                <span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-primary animate-pulse-soft"></span>
                FAQs
              </div>
              <h2 className="mb-1.5 md:mb-2 text-xl md:text-2xl font-bold tracking-tight text-slate-800">
                <span className="text-gradient">Frequently</span> Asked Questions
              </h2>
            </div>

            {loading ? (
              <p className="text-center text-slate-600">Loading FAQs...</p>
            ) : faqItems.length === 0 ? (
              <p className="text-center text-slate-500">No data found.</p>
            ) : (
              <>
                <div className="space-y-2">
                  {faqItems.slice(0, visibleCount).map((item, index) => (
                    <div
                      key={index}
                      className="border-b border-slate-200 transition-all duration-300 hover:border-primary/30 group"
                    >
                      <button
                        onClick={() => toggleFaq(index)}
                        className="w-full flex items-center justify-between text-left cursor-pointer py-4 text-base md:text-lg font-medium hover:text-primary transition-all duration-300"
                      >
                        {item.question}
                        <svg
                          className={`h-4 w-4 transform transition-transform duration-200 ${activeIndex === index ? 'rotate-180' : ''}`}
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                      {activeIndex === index && (
                        <div className="pb-4 text-sm text-slate-600">
                          {item.answer}
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {/* Load More Button */}
                {visibleCount < faqItems.length && (
                  <div className="mt-6 text-center">
                    <button
                      onClick={() => setVisibleCount(prev => prev + 4)}
                      className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none_s h-9 rounded-md px-3 bg-primary text-white hover:bg-primary/90"
                    >
                      Load More
                    </button>
                  </div>
                )}
              </>
            )}

            {/* Scroll Prompt for Mobile */}
            <div className="mt-3 flex items-center justify-center gap-1 md:hidden">
              <svg
                className="h-4 w-4 animate-bounce text-blue-600"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span className="text-xs text-blue-600">Scroll for more</span>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Faq;
